import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateSubmittedV1DataSchema } from "./estimate-review-shared";

const InsuranceEstimateSubmittedDataSchema = z.discriminatedUnion("version", [EstimateSubmittedV1DataSchema]);

export const InsuranceEstimateSubmittedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_ESTIMATE_SUBMITTED),
  data: InsuranceEstimateSubmittedDataSchema,
});
